const tsDataReading = {
  scale1: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": 0.0,
    "Interpret Words & Phrases": 0.0,
    "Intent & Purpose": 0.0,
    "Point of View": 0.0,
    "Analyze Structure": null,
    Function: 0.0,
    "Relate to Passage as a Whole": 0.0,
    "Identifying Claims": null,
    "Supporting Claims": 0.0,
    "Compare Two Texts": 0.0,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": 0.0,
    "Summarize Key Ideas & Details": 0.0,
    "Draw Conclusions": 0.0,
    Locate: 0.0,
    Paraphrase: 0.0,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": 0.0
  },
  scale2: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": 0.0,
    "Interpret Words & Phrases": 0.0395954,
    "Intent & Purpose": 0.0,
    "Point of View": 0.0433526,
    "Analyze Structure": null,
    Function: 0.0,
    "Relate to Passage as a Whole": 0.0512821,
    "Identifying Claims": null,
    "Supporting Claims": 0.0,
    "Compare Two Texts": 0.0,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": 0.0714286,
    "Summarize Key Ideas & Details": 0.0635838,
    "Draw Conclusions": 0.018315,
    Locate: 0.0316793,
    Paraphrase: 0.0,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": 0.0952381
  },
  scale3: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": null,
    "Interpret Words & Phrases": 0,
    "Intent & Purpose": 0.0220386,
    "Point of View": 0,
    "Analyze Structure": null,
    Function: 0,
    "Relate to Passage as a Whole": 0.0,
    "Identifying Claims": null,
    "Supporting Claims": 0.0247934,
    "Compare Two Texts": null,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": null,
    "Summarize Key Ideas & Details": 0,
    "Draw Conclusions": 0.0590319,
    Locate: 0,
    Paraphrase: 0,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": null
  },
  scale4: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": 0.025641,
    "Interpret Words & Phrases": 0,
    "Intent & Purpose": null,
    "Point of View": 0,
    "Analyze Structure": null,
    Function: 0,
    "Relate to Passage as a Whole": null,
    "Identifying Claims": null,
    "Supporting Claims": null,
    "Compare Two Texts": 0.025641,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": 0.0961538,
    "Summarize Key Ideas & Details": 0,
    "Draw Conclusions": null,
    Locate: 0,
    Paraphrase: 0,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": 0.179487
  },
  scale5: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": null,
    "Interpret Words & Phrases": 0,
    "Intent & Purpose": 0.0460405,
    "Point of View": 0,
    "Analyze Structure": null,
    Function: 0,
    "Relate to Passage as a Whole": 0.0110497,
    "Identifying Claims": null,
    "Supporting Claims": 0.0939227,
    "Compare Two Texts": null,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": null,
    "Summarize Key Ideas & Details": 0,
    "Draw Conclusions": 0.0812944,
    Locate: 0,
    Paraphrase: 0,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": null
  },
  scale6: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": 0.0,
    "Interpret Words & Phrases": 0.0762859,
    "Intent & Purpose": 0.0690608,
    "Point of View": 0.121407,
    "Analyze Structure": null,
    Function: 0.0824508,
    "Relate to Passage as a Whole": 0.0303867,
    "Identifying Claims": null,
    "Supporting Claims": 0.132597,
    "Compare Two Texts": 0.0225989,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": 0.254237,
    "Summarize Key Ideas & Details": 0.0748865,
    "Draw Conclusions": 0.0923441,
    Locate: 0.129369,
    Paraphrase: 0.0493192,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": 0.129944
  },
  scale7: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": 0.037037,
    "Interpret Words & Phrases": 0.0956989,
    "Intent & Purpose": 0.0901961,
    "Point of View": 0.179785,
    "Analyze Structure": null,
    Function: 0.092043,
    "Relate to Passage as a Whole": 0.107563,
    "Identifying Claims": null,
    "Supporting Claims": 0.240336,
    "Compare Two Texts": 0.0518519,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": 0.185185,
    "Summarize Key Ideas & Details": 0.111398,
    "Draw Conclusions": 0.129892,
    Locate: 0.127658,
    Paraphrase: 0.0747527,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": 0.153086
  },
  scale8: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": 0.0677656,
    "Interpret Words & Phrases": 0.125446,
    "Intent & Purpose": 0.109336,
    "Point of View": 0.167985,
    "Analyze Structure": null,
    Function: 0.131633,
    "Relate to Passage as a Whole": 0.147556,
    "Identifying Claims": null,
    "Supporting Claims": 0.183271,
    "Compare Two Texts": 0.0604396,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": 0.236264,
    "Summarize Key Ideas & Details": 0.112117,
    "Draw Conclusions": 0.156686,
    Locate: 0.157381,
    Paraphrase: 0.113112,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": 0.21978
  },
  scale9: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": null,
    "Interpret Words & Phrases": 0,
    "Intent & Purpose": 0.149551,
    "Point of View": 0,
    "Analyze Structure": null,
    Function: 0,
    "Relate to Passage as a Whole": 0.15982,
    "Identifying Claims": null,
    "Supporting Claims": 0.22914,
    "Compare Two Texts": null,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": null,
    "Summarize Key Ideas & Details": 0,
    "Draw Conclusions": 0.168073,
    Locate: 0,
    Paraphrase: 0,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": null
  },
  scale10: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": 0.10533,
    "Interpret Words & Phrases": 0.167834,
    "Intent & Purpose": 0.167025,
    "Point of View": 0.217864,
    "Analyze Structure": null,
    Function: 0.169598,
    "Relate to Passage as a Whole": 0.194576,
    "Identifying Claims": null,
    "Supporting Claims": 0.233319,
    "Compare Two Texts": 0.119289,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": 0.237944,
    "Summarize Key Ideas & Details": 0.169005,
    "Draw Conclusions": 0.198512,
    Locate: 0.188591,
    Paraphrase: 0.168126,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": 0.247462
  },
  scale11: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": 0.156063,
    "Interpret Words & Phrases": 0.206332,
    "Intent & Purpose": 0.206667,
    "Point of View": 0.267138,
    "Analyze Structure": null,
    Function: 0.200912,
    "Relate to Passage as a Whole": 0.254016,
    "Identifying Claims": null,
    "Supporting Claims": 0.279213,
    "Compare Two Texts": 0.185971,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": 0.261827,
    "Summarize Key Ideas & Details": 0.192029,
    "Draw Conclusions": 0.231564,
    Locate: 0.247115,
    Paraphrase: 0.186252,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": 0.252855
  },
  scale12: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": 0.188045,
    "Interpret Words & Phrases": 0.250024,
    "Intent & Purpose": 0.233935,
    "Point of View": 0.325839,
    "Analyze Structure": null,
    Function: 0.265855,
    "Relate to Passage as a Whole": 0.303105,
    "Identifying Claims": null,
    "Supporting Claims": 0.333285,
    "Compare Two Texts": 0.196347,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": 0.317248,
    "Summarize Key Ideas & Details": 0.228722,
    "Draw Conclusions": 0.274801,
    Locate: 0.283944,
    Paraphrase: 0.230626,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": 0.309672
  },
  scale13: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": 0.241326,
    "Interpret Words & Phrases": 0.289949,
    "Intent & Purpose": 0.257824,
    "Point of View": 0.387938,
    "Analyze Structure": null,
    Function: 0.308062,
    "Relate to Passage as a Whole": 0.298643,
    "Identifying Claims": null,
    "Supporting Claims": 0.352941,
    "Compare Two Texts": 0.263548,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": 0.346784,
    "Summarize Key Ideas & Details": 0.248503,
    "Draw Conclusions": 0.304945,
    Locate: 0.334348,
    Paraphrase: 0.234189,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": 0.383236
  },
  scale14: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": 0.271075,
    "Interpret Words & Phrases": 0.332002,
    "Intent & Purpose": 0.259408,
    "Point of View": 0.453815,
    "Analyze Structure": null,
    Function: 0.34675,
    "Relate to Passage as a Whole": 0.37309,
    "Identifying Claims": null,
    "Supporting Claims": 0.382733,
    "Compare Two Texts": 0.287703,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": 0.402842,
    "Summarize Key Ideas & Details": 0.28563,
    "Draw Conclusions": 0.336576,
    Locate: 0.367293,
    Paraphrase: 0.254279,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": 0.45553
  },
  scale15: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": 0.275615,
    "Interpret Words & Phrases": 0.38666,
    "Intent & Purpose": 0.280066,
    "Point of View": 0.547781,
    "Analyze Structure": null,
    Function: 0.441465,
    "Relate to Passage as a Whole": 0.425163,
    "Identifying Claims": null,
    "Supporting Claims": 0.467731,
    "Compare Two Texts": 0.298881,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": 0.418121,
    "Summarize Key Ideas & Details": 0.288616,
    "Draw Conclusions": 0.371169,
    Locate: 0.451083,
    Paraphrase: 0.289725,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": 0.5217
  },
  scale16: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": 0.307264,
    "Interpret Words & Phrases": 0.403459,
    "Intent & Purpose": 0.299334,
    "Point of View": 0.580688,
    "Analyze Structure": null,
    Function: 0.470699,
    "Relate to Passage as a Whole": 0.470441,
    "Identifying Claims": null,
    "Supporting Claims": 0.48751,
    "Compare Two Texts": 0.333333,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": 0.482156,
    "Summarize Key Ideas & Details": 0.359989,
    "Draw Conclusions": 0.411443,
    Locate: 0.429448,
    Paraphrase: 0.316114,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": 0.560871
  },
  scale17: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": 0.300891,
    "Interpret Words & Phrases": 0.441469,
    "Intent & Purpose": 0.298084,
    "Point of View": 0.633105,
    "Analyze Structure": null,
    Function: 0.552256,
    "Relate to Passage as a Whole": 0.48,
    "Identifying Claims": null,
    "Supporting Claims": 0.522759,
    "Compare Two Texts": 0.367048,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": 0.526718,
    "Summarize Key Ideas & Details": 0.359587,
    "Draw Conclusions": 0.429688,
    Locate: 0.502702,
    Paraphrase: 0.320984,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": 0.657761
  },
  scale18: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": 0.325112,
    "Interpret Words & Phrases": 0.482374,
    "Intent & Purpose": 0.330775,
    "Point of View": 0.665088,
    "Analyze Structure": null,
    Function: 0.625786,
    "Relate to Passage as a Whole": 0.568688,
    "Identifying Claims": null,
    "Supporting Claims": 0.57892,
    "Compare Two Texts": 0.347534,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": 0.507848,
    "Summarize Key Ideas & Details": 0.349345,
    "Draw Conclusions": 0.451376,
    Locate: 0.566691,
    Paraphrase: 0.35235,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": 0.71151
  },
  scale19: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": 0.369666,
    "Interpret Words & Phrases": 0.519774,
    "Intent & Purpose": 0.360371,
    "Point of View": 0.702844,
    "Analyze Structure": null,
    Function: 0.62455,
    "Relate to Passage as a Whole": 0.636153,
    "Identifying Claims": null,
    "Supporting Claims": 0.626304,
    "Compare Two Texts": 0.386565,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": 0.54943,
    "Summarize Key Ideas & Details": 0.428906,
    "Draw Conclusions": 0.481046,
    Locate: 0.53301,
    Paraphrase: 0.39604,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": 0.74736
  },
  scale20: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": 0.406844,
    "Interpret Words & Phrases": 0.543962,
    "Intent & Purpose": 0.388355,
    "Point of View": 0.752994,
    "Analyze Structure": null,
    Function: 0.731416,
    "Relate to Passage as a Whole": 0.68346,
    "Identifying Claims": null,
    "Supporting Claims": 0.68114,
    "Compare Two Texts": 0.453739,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": 0.619772,
    "Summarize Key Ideas & Details": 0.399139,
    "Draw Conclusions": 0.523983,
    Locate: 0.633038,
    Paraphrase: 0.422627,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": 0.801014
  },
  scale21: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": 0.414258,
    "Interpret Words & Phrases": 0.586268,
    "Intent & Purpose": 0.405685,
    "Point of View": 0.803818,
    "Analyze Structure": null,
    Function: 0.695257,
    "Relate to Passage as a Whole": 0.757364,
    "Identifying Claims": null,
    "Supporting Claims": 0.712403,
    "Compare Two Texts": 0.486191,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": 0.641618,
    "Summarize Key Ideas & Details": 0.520013,
    "Draw Conclusions": 0.56268,
    Locate: 0.603571,
    Paraphrase: 0.470972,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": 0.831085
  },
  scale22: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": 0.494993,
    "Interpret Words & Phrases": 0.610817,
    "Intent & Purpose": 0.464897,
    "Point of View": 0.796738,
    "Analyze Structure": null,
    Function: 0.761684,
    "Relate to Passage as a Whole": 0.795575,
    "Identifying Claims": null,
    "Supporting Claims": 0.753097,
    "Compare Two Texts": 0.563662,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": 0.660944,
    "Summarize Key Ideas & Details": 0.490398,
    "Draw Conclusions": 0.584071,
    Locate: 0.658708,
    Paraphrase: 0.500602,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": 0.872675
  },
  scale23: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": 0.524917,
    "Interpret Words & Phrases": 0.634343,
    "Intent & Purpose": 0.492775,
    "Point of View": 0.813134,
    "Analyze Structure": null,
    Function: 0.831163,
    "Relate to Passage as a Whole": 0.803448,
    "Identifying Claims": null,
    "Supporting Claims": 0.76601,
    "Compare Two Texts": 0.584718,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": 0.677741,
    "Summarize Key Ideas & Details": 0.509254,
    "Draw Conclusions": 0.606897,
    Locate: 0.708859,
    Paraphrase: 0.526104,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": 0.900332
  },
  scale24: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": 0.660377,
    "Interpret Words & Phrases": 0.686816,
    "Intent & Purpose": 0.556344,
    "Point of View": 0.852633,
    "Analyze Structure": null,
    Function: 0.844024,
    "Relate to Passage as a Whole": 0.869976,
    "Identifying Claims": null,
    "Supporting Claims": 0.823877,
    "Compare Two Texts": 0.578616,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": 0.665094,
    "Summarize Key Ideas & Details": 0.522789,
    "Draw Conclusions": 0.651976,
    Locate: 0.739878,
    Paraphrase: 0.562053,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": 0.90566
  },
  scale25: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": 0.654971,
    "Interpret Words & Phrases": 0.715356,
    "Intent & Purpose": 0.602529,
    "Point of View": 0.832584,
    "Analyze Structure": null,
    Function: 0.866854,
    "Relate to Passage as a Whole": 0.898374,
    "Identifying Claims": null,
    "Supporting Claims": 0.821138,
    "Compare Two Texts": 0.692982,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": 0.70614,
    "Summarize Key Ideas & Details": 0.555243,
    "Draw Conclusions": 0.664925,
    Locate: 0.758052,
    Paraphrase: 0.573783,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": 0.923977
  },
  scale26: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": 0.677536,
    "Interpret Words & Phrases": 0.71887,
    "Intent & Purpose": 0.605753,
    "Point of View": 0.879028,
    "Analyze Structure": null,
    Function: 0.898879,
    "Relate to Passage as a Whole": 0.869712,
    "Identifying Claims": null,
    "Supporting Claims": 0.869712,
    "Compare Two Texts": 0.666667,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": 0.755435,
    "Summarize Key Ideas & Details": 0.607894,
    "Draw Conclusions": 0.677061,
    Locate: 0.795884,
    Paraphrase: 0.609248,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": 0.905797
  },
  scale27: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": 0.714286,
    "Interpret Words & Phrases": 0.730119,
    "Intent & Purpose": 0.635359,
    "Point of View": 0.885036,
    "Analyze Structure": null,
    Function: 0.867696,
    "Relate to Passage as a Whole": 0.909761,
    "Identifying Claims": null,
    "Supporting Claims": 0.915285,
    "Compare Two Texts": 0.803922,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": 0.789916,
    "Summarize Key Ideas & Details": 0.637055,
    "Draw Conclusions": 0.723757,
    Locate: 0.797514,
    Paraphrase: 0.647411,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": 0.938375
  },
  scale28: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": 0.713725,
    "Interpret Words & Phrases": 0.75572,
    "Intent & Purpose": 0.699332,
    "Point of View": 0.90575,
    "Analyze Structure": null,
    Function: 0.911381,
    "Relate to Passage as a Whole": 0.917595,
    "Identifying Claims": null,
    "Supporting Claims": 0.870824,
    "Compare Two Texts": 0.745098,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": 0.829412,
    "Summarize Key Ideas & Details": 0.652638,
    "Draw Conclusions": 0.740694,
    Locate: 0.817897,
    Paraphrase: 0.680616,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": 0.952941
  },
  scale29: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": 0.731183,
    "Interpret Words & Phrases": 0.760387,
    "Intent & Purpose": 0.754435,
    "Point of View": 0.921911,
    "Analyze Structure": null,
    Function: 0.921531,
    "Relate to Passage as a Whole": 0.929972,
    "Identifying Claims": null,
    "Supporting Claims": 0.89916,
    "Compare Two Texts": 0.865591,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": 0.725806,
    "Summarize Key Ideas & Details": 0.692191,
    "Draw Conclusions": 0.777111,
    Locate: 0.854681,
    Paraphrase: 0.689007,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": 0.919355
  },
  scale30: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": 0.79798,
    "Interpret Words & Phrases": 0.793396,
    "Intent & Purpose": 0.765651,
    "Point of View": 0.942254,
    "Analyze Structure": null,
    Function: 0.943638,
    "Relate to Passage as a Whole": 0.954315,
    "Identifying Claims": null,
    "Supporting Claims": 0.956853,
    "Compare Two Texts": 0.868687,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": 0.909091,
    "Summarize Key Ideas & Details": 0.744813,
    "Draw Conclusions": 0.793328,
    Locate: 0.867283,
    Paraphrase: 0.706639,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": 0.944444
  },
  scale31: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": 0.906977,
    "Interpret Words & Phrases": 0.798404,
    "Intent & Purpose": 0.785156,
    "Point of View": 0.931915,
    "Analyze Structure": null,
    Function: 0.935638,
    "Relate to Passage as a Whole": 0.933594,
    "Identifying Claims": null,
    "Supporting Claims": 0.964844,
    "Compare Two Texts": 0.821705,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": 0.860465,
    "Summarize Key Ideas & Details": 0.744149,
    "Draw Conclusions": 0.825335,
    Locate: 0.880354,
    Paraphrase: 0.774468,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": 0.953488
  },
  scale32: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": 0.932099,
    "Interpret Words & Phrases": 0.813664,
    "Intent & Purpose": 0.865,
    "Point of View": 0.943627,
    "Analyze Structure": null,
    Function: 0.947917,
    "Relate to Passage as a Whole": 0.955,
    "Identifying Claims": null,
    "Supporting Claims": 0.97,
    "Compare Two Texts": 0.901235,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": 0.87037,
    "Summarize Key Ideas & Details": 0.834559,
    "Draw Conclusions": 0.880714,
    Locate: 0.917017,
    Paraphrase: 0.790686,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": 0.95679
  },
  scale33: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": 0.96,
    "Interpret Words & Phrases": 0,
    "Intent & Purpose": null,
    "Point of View": 0,
    "Analyze Structure": null,
    Function: 0,
    "Relate to Passage as a Whole": null,
    "Identifying Claims": null,
    "Supporting Claims": null,
    "Compare Two Texts": 0.906667,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": 0.92,
    "Summarize Key Ideas & Details": 0,
    "Draw Conclusions": null,
    Locate: 0,
    Paraphrase: 0,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": 1.0
  },
  scale34: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": 0.942029,
    "Interpret Words & Phrases": 0.854854,
    "Intent & Purpose": 0.879433,
    "Point of View": 0.976699,
    "Analyze Structure": null,
    Function: 0.976699,
    "Relate to Passage as a Whole": 0.978723,
    "Identifying Claims": null,
    "Supporting Claims": 0.985816,
    "Compare Two Texts": 0.985507,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": 0.913043,
    "Summarize Key Ideas & Details": 0.834951,
    "Draw Conclusions": 0.902736,
    Locate: 0.955062,
    Paraphrase: 0.807379,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": 0.942029
  },
  scale35: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": 1.0,
    "Interpret Words & Phrases": 0.84985,
    "Intent & Purpose": 0.959839,
    "Point of View": 0.977477,
    "Analyze Structure": null,
    Function: 0.93994,
    "Relate to Passage as a Whole": 1.0,
    "Identifying Claims": null,
    "Supporting Claims": 0.987952,
    "Compare Two Texts": 0.952381,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": 1.0,
    "Summarize Key Ideas & Details": 0.896396,
    "Draw Conclusions": 0.939759,
    Locate: 0.972661,
    Paraphrase: 0.902102,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": 1.0
  },
  scale36: {
    "Sequence of Events": null,
    "Central Ideas": null,
    "Analyze Word & Phrase Choices": 1.0,
    "Interpret Words & Phrases": 0.925431,
    "Intent & Purpose": 1.0,
    "Point of View": 1.0,
    "Analyze Structure": null,
    Function: 1.0,
    "Relate to Passage as a Whole": 1.0,
    "Identifying Claims": null,
    "Supporting Claims": 1.0,
    "Compare Two Texts": 1.0,
    "Conclusions Two Texts": null,
    "Central Ideas & Themes": 1.0,
    "Summarize Key Ideas & Details": 0.974138,
    "Draw Conclusions": 0.994898,
    Locate: 0.997649,
    Paraphrase: 0.944828,
    "Cause-Effect Relationships": null,
    "Comparative Relationships": 1.0
  }
}

export default tsDataReading
